module.exports = {"140224100":"武灵镇","140224101":"东河南镇","140224102":"上寨镇","140224200":"落水河乡","140224203":"史庄乡","140224205":"赵北乡","140224206":"石家田乡","140224207":"柳科乡","140224208":"白崖台乡","140224210":"红石塄乡","140224212":"下关乡","140224213":"独峪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140224.json
// module id = 280
// module chunks = 0